import ozToggleDatazap from './oz-toggle-datazap.vue'

export default ozToggleDatazap
